import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=4ad412f1"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports